<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <el-form :model="questionForm" :rules="rules" ref="questionForm" label-width="100px" class="demo-noticeForm">
        <el-form-item label="题目类型：" prop="type">
          <el-radio-group v-model="questionForm.type">
            <el-radio :label="1">单选题</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="试题分类：" prop="mold">
          <el-select v-model="questionForm.mold" multiple placeholder="请选择试题分类(可多选)" style="width: 100%">
            <el-option
              v-for="item in moldList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题题干：" prop="title">
          <VueUditorWrap v-model="questionForm.title" :config="myConfig"></VueUditorWrap>
        </el-form-item>
        <el-form-item label="答案选项：" prop="option">
          <el-radio-group v-model="questionForm.option">
            <div v-for="(item,index) in questionForm.optionList" :key="item.op"
                 class="flex align-center margin-bottom-sm">
              <el-radio :label="item.option" :value="item.option"></el-radio>
              <el-form-item label-width="0"
                            :prop="'optionList.' + index + '.content'"
                            :rules="[{ required: true, message: '请输入答案选项', trigger: 'blur' }]"
              >
                <el-input v-model="questionForm.optionList[index].content" placeholder="请输入答案选项"
                          style="width: 600px;"></el-input>
              </el-form-item>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm('questionForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils";
import {questionCateList, questionDetail, updateQuestion} from "@/api/study";

export default {
  name: "questions-edit",
  data() {
    return {
      id: '',
      moldList: [],
      questionForm: {
        type: 1,
        mold: [],
        title: '',
        option: '',
        optionList: [
          {option: 'A', content: ''},
          {option: 'B', content: ''},
          {option: 'C', content: ''},
          {option: 'D', content: ''},
        ]
      },
      rules: {
        type: [{required: true, message: '题目类型', trigger: 'change'},],
        mold: [{type: 'array', required: true, message: '请至少选择一个试题分类', trigger: 'change'},],
        title: [{required: true, message: '请输入试题题干', trigger: 'blur'},],
        option: [{required: true, message: '请设置正确答案', trigger: 'change'},],

      },
      myConfig: bdEditConfig()
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/questions-list', "双暖为老 / 试题编辑", true);
    this.getList()
    if (Number(this.$route.params.id)) this.id = this.$route.params.id, this.getDetail()
  },
  components: {
    VueUditorWrap
  },
  methods: {
    //  获取列表
    async getDetail() {
      const res = await questionDetail(this.$route.params.id)
      this.questionForm = {
        type: res.data.type,
        mold: res.data.cate_ids.split(',').map(Number),
        title: res.data.question,
        option: res.data.answer,
        optionList: res.data.option
      }
    },
    //  获取列表
    async getList() {
      const res = await questionCateList('', 1, 1000)
      this.moldList = res.data
    },

    //  提交试题
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitQuestion()
        }
      });
    },
    async submitQuestion() {
      let _state = await updateQuestion(this.questionForm.type,
        this.questionForm.mold.join(','), this.questionForm.title,
        JSON.stringify(this.questionForm.optionList),
        this.questionForm.option,'', this.id)
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
